define('home/views/ForumCountCardCollectionView',[
    'home/views/ForumCountCardView',
    'home/views/ForumCardCollectionView',
], function (
    ForumCountCardView,
    ForumCardCollectionView
) {
    'use strict';

    /**
     * Shows a list of channel cards with channel stats and the follow button.
     * It extends from ForumCardCollectionView where it adds in an empty state.
     &
     * Expects a collection of Forums or Channels with a link to their primaryForums.
     */
    var ForumCountCardCollectionView = ForumCardCollectionView.extend({
        itemView: ForumCountCardView,
    });

    return ForumCountCardCollectionView;
});

